import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-update-overlay" }
const _hoisted_2 = { class: "container-sm h-100" }
const _hoisted_3 = { class: "row title-row" }
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col text-left" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col text-left text-danger pw-warning-message" }
const _hoisted_11 = { class: "row my-2 justify-content-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "password-input-form-overlay input-form-overlay" }
const _hoisted_14 = { class: "row my-1" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row my-2 justify-content-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "mail-input-form-overlay input-form-overlay" }
const _hoisted_20 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordInput = _resolveComponent("PasswordInput")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "row dummy-row" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "col h2 title-col",
              style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
            }, "認証情報の更新", 4)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createTextVNode("サービスを利用するには", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.authStore.getters.shouldUpdatePassword ? 'text-should-update' : 'text-updated')
              }, "初期パスワードを変更", 2),
              _cache[9] || (_cache[9] = _createTextVNode("し、", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.authStore.getters.shouldVerifyMail ? 'text-should-update' : 'text-updated')
              }, "メールアドレスを登録", 2),
              _cache[10] || (_cache[10] = _createTextVNode("します。", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col password-input-form input-form", {'input-form-should-update': _ctx.authStore.getters.shouldUpdatePassword}])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col h3" }, "パスワードの変更")
                ], -1)),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row justify-content-start" }, [
                  _createElementVNode("div", { class: "col text-left" }, "新しいパスワード")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_PasswordInput, {
                    password: _ctx.password1,
                    "onUpdate:password": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password1) = $event)),
                    class: "col"
                  }, null, 8, ["password"])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row justify-content-start" }, [
                  _createElementVNode("div", { class: "col text-left" }, "新しいパスワード（確認）")
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_PasswordInput, {
                    password: _ctx.password2,
                    "onUpdate:password": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password2) = $event)),
                    class: "col"
                  }, null, 8, ["password"])
                ]),
                _createElementVNode("div", {
                  class: "row justify-content-start my-2 warning-row",
                  style: _normalizeStyle({fontSize: _ctx.FontSizes.small1})
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.pwWarningMessage), 1)
                ], 4),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "col-10 btn btn-primary",
                    disabled: !_ctx.canClickUpdatePW,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickUpdatePassword && _ctx.onClickUpdatePassword(...args)))
                  }, "パスワードを変更する", 8, _hoisted_12)
                ])
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_13, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "updated-text" }, "初期パスワード変更済み", -1)),
                    _createElementVNode("button", {
                      class: "re-update-pw-button btn btn-info re-update-button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickReChangePW && _ctx.onClickReChangePW(...args)))
                    }, "パスワードを再変更")
                  ], 512), [
                    [_vShow, _ctx.showPWFormOverlay]
                  ])
                ]),
                _: 1
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["col mail-input-form input-form", {'input-form-should-update': _ctx.authStore.getters.shouldVerifyMail}])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col h3" }, "メールアドレスの変更")
                ], -1)),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row justify-content-start" }, [
                  _createElementVNode("div", { class: "col text-left" }, "メールアドレス")
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                    class: "col input-frame"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row justify-content-start" }, [
                  _createElementVNode("div", { class: "col mail-explain text-left" }, "キャリアメールは非推奨とします(@docomo、@au、@softbankなど)。 もしキャリアメールを使用される場合には、本システムからのメールを受信できない場合がありますが、これにより生じた損害等について当社が責任を負うものではないことを了承いただいたものとみなします。 ")
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row justify-content-start my-2" }, [
                  _createElementVNode("div", { class: "col text-left" }, [
                    _createTextVNode("確認メールを送信し、届いたメールの「確認リンク」を押してください。"),
                    _createElementVNode("br"),
                    _createTextVNode("（確認メールの到達には数分かかることがあります。）")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "col-10 btn btn-primary",
                    disabled: !_ctx.canClickSendMail(),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickSendVerificationMail && _ctx.onClickSendVerificationMail(...args)))
                  }, _toDisplayString(_ctx.sendMailButtonText()), 9, _hoisted_18)
                ])
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_19, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "updated-text" }, "メール確認済み", -1)),
                    _createElementVNode("button", {
                      class: "re-update-mail-button btn btn-info re-update-button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickReVerifyMail && _ctx.onClickReVerifyMail(...args)))
                    }, "メールアドレスを再変更")
                  ], 512), [
                    [_vShow, _ctx.showMailFormOverlay]
                  ])
                ]),
                _: 1
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-6 col-2" }, null, -1)),
            _createElementVNode("button", {
              class: "btn btn-secondary col-8 col-md-6",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClickCancelUpdate && _ctx.onClickCancelUpdate(...args)))
            }, _toDisplayString(_ctx.cancelText), 1)
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "dummy-row" }, null, -1))
        ])
      ], 512), [
        [_vShow, _ctx.authUpdateOverlayStateStore.state.show]
      ])
    ]),
    _: 1
  }))
}